import { render, staticRenderFns } from "./CompareAnidData.vue?vue&type=template&id=5eda4fb5&scoped=true"
import script from "./CompareAnidData.vue?vue&type=script&lang=js"
export * from "./CompareAnidData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda4fb5",
  null
  
)

export default component.exports